// FIXME: Merge this with username types when we normalize all user data
export const BEGIN_FETCH_USER = 'BEGIN_FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR'
